/**
 * Created by George on 2018/5/25.
 */

const SessionStorage = {
  setItem(key, value) {
    const valueStr = JSON.stringify(value)
    sessionStorage.setItem(key, valueStr)
  },
  getItem(key) {
    const result = sessionStorage.getItem(key)
    return JSON.parse(result)
  },
  isItemExist(key) {
    const result = sessionStorage.getItem(key)
    if (result === undefined || JSON.stringify(result) === '{}' || result === '' || result === null) {
      return false
    }
    return true
  },
  removeItem(key) {
    sessionStorage.removeItem(key)
  }
}
const LocalStorage = {
  setItem(key, value) {
    const valueStr = JSON.stringify(value)
    localStorage.setItem(key, valueStr)
  },
  getItem(key) {
    const result = localStorage.getItem(key)
    return JSON.parse(result)
  },
  isItemExist(key) {
    const result = localStorage.getItem(key)
    if (result === undefined || JSON.stringify(result) === '{}' || result === '' || result === null) {
      return false
    }
    return true
  },
  removeItem(key) {
    localStorage.removeItem(key)
  }
}

export {
  SessionStorage,
  LocalStorage
}
